import { initLine } from '@components/minicart';
import { execOnLoad, formatPrice } from '@general/helpers';
import './cart-page.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initCartPage = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const animationDuration = 350;
  const cartTotal = sectionContainer.querySelector('[data-items-subtotal]');
  const cartOriginal = sectionContainer.querySelector('[data-items-original]');
  const submit = sectionContainer.querySelector('[type="submit"]');
  const freeShipping = sectionContainer.querySelector(
    '.cart-page__free-shipping',
  );
  const emptyCart = sectionContainer.querySelector('.cart-page__empty');
  const updateCart = (cart) => {
    sectionContainer
      .querySelectorAll('.cart-line__wrapper[data-id]')
      .forEach((line) => {
        const item = cart.items.find((item) => item.id == line.dataset.id);
        if (item) {
          line.dataset.key = item.key;
          const price = line.querySelector('.cart-line__total > span');
          if (price)
            price.innerText = formatPrice({
              value: item.final_line_price,
            });

          const discountedPrice = line.querySelector('.cart-line__total > del');
          if (discountedPrice)
            discountedPrice.innerText =
              item.original_line_price != item.final_line_price
                ? formatPrice({
                    value: item.original_line_price,
                  })
                : '';

          const discountsWrapper = line.querySelector(
            '.cart-line__total-discounts',
          );
          if (discountsWrapper) {
            discountsWrapper.innerHTML = '';
            item.line_level_discount_allocations.forEach(
              (discountAllocations) => {
                const title = discountAllocations?.discount_application?.title;
                if (!title) return;
                const discountTitle = document.createElement('span');
                discountTitle.innerText = title;
                discountsWrapper.appendChild(discountTitle);
              },
            );
          }
        } else {
          line.style.height = `${line.clientHeight}px`;
          line.style.transition = `height ${animationDuration}ms`;
          window.requestAnimationFrame(() => {
            line.style.height = '0px';
            setTimeout(() => {
              line.remove();
            }, animationDuration);
          });
        }
        line.classList.remove('loading');
      });

    if (cartTotal)
      cartTotal.innerText = formatPrice({
        value: cart.items_subtotal_price,
      });
    if (cartOriginal) {
      const originalWrapper = cartOriginal.closest('.cart-page__totals-value');
      if (originalWrapper) {
        if (cart.original_total_price != cart.items_subtotal_price)
          originalWrapper.classList.remove('hidden');
        else originalWrapper.classList.add('hidden');
      }
      cartOriginal.innerText =
        cart.original_total_price != cart.items_subtotal_price
          ? formatPrice({
              value: cart.original_total_price,
            })
          : '';
    }
    if (submit) submit.disabled = cart.item_count <= 0;
    if (emptyCart) {
      if (cart.item_count <= 0) {
        emptyCart.classList.remove('hidden');
      } else {
        emptyCart.classList.add('hidden');
      }
    }

    if (freeShipping) {
      const bar = freeShipping.querySelector(
        '.cart-page__free-shipping-bar[data-threshold]',
      );
      const progress = freeShipping.querySelector(
        '.cart-page__free-shipping-bar-progress',
      );
      const incomplete = freeShipping.querySelector('[data-threshold-missing]');

      if (bar && progress && incomplete) {
        const threshold = parseInt(bar.dataset.threshold);
        const remaining = threshold - cart.items_subtotal_price;
        const progressPercentage =
          remaining > 0 ? (cart.items_subtotal_price * 100) / threshold : 100;
        bar.dataset.progress = progressPercentage;
        progress.style.width = `${progressPercentage}%`;
        incomplete.innerText = formatPrice({ value: remaining });
      }
    }
  };

  sectionContainer
    .querySelectorAll('.cart-line__wrapper[data-id]')
    .forEach((line) =>
      initLine({
        line,
        beforeFetch: () => {
          line.classList.add('loading');
        },
        afterFetch: updateCart,
      }),
    );
};

execOnLoad(window.dAgency.initCartPage, '.cart-page__section');
